import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "../hooks/apiRequest";
import { EpicProps } from "../types/interfaces";
import { epicKeys } from "../utils/queryKeys";

export function useEpics(projectId: string) {
  return useQuery({
    queryKey: epicKeys.list(projectId),
    queryFn: async () => (await apiRequest<EpicProps[]>(`projects/${projectId}/epics`)).data,
    enabled: !!projectId,
  });
}

export function useCreateEpic(projectId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { title: string; description?: string; color?: string }) =>
      (await apiRequest<EpicProps>(`projects/${projectId}/epics`, {
        method: "POST",
        body: JSON.stringify(data),
      })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: epicKeys.list(projectId) }),
  });
}
